export default "__VITE_ASSET__BY7y3oP___"